// hooks/useRecaptcha.ts
"use client";
import { verifyRecaptcha } from "@/utils/actions/recaptcha";
import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export function useRecaptcha() {
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);

  const handleRecaptchaChange = (token: string | null) => {
    setRecaptchaToken(token);
  };
  const verifyToken = async () => {
    if (!recaptchaToken) {
      return {
        success: false,
        message: "Please complete the reCAPTCHA verification",
      };
    }

    const isValid = await verifyRecaptcha(recaptchaToken);
    // console.log("reCAPTCHA verification result:", isValid);

    if (!isValid) {
      return {
        success: false,
        message: "reCAPTCHA verification failed",
      };
    }
    return {
      success: true,
      message: "reCAPTCHA verification successful",
    };
  };

  const reset = () => {
    recaptchaRef.current?.reset();
    setRecaptchaToken(null); // Clear the token when resetting
  };
  return {
    recaptchaRef,
    recaptchaToken,
    setRecaptchaToken,
    verifyToken,
    reset,
    handleRecaptchaChange,
  };
}
